import React from 'react';
import { PRIMARY, cn } from '../constants/theme';
import { ThemeToggle } from './ThemeToggle';

interface HeaderProps {
  dark: boolean;
  onToggleDark: () => void;
  onGoNotes: () => void;
  variant?: 'home' | 'blog';
  onGoHome?: () => void;
}

export function Header({
  dark,
  onToggleDark,
  onGoNotes,
  variant = 'home',
  onGoHome,
}: HeaderProps) {
  if (variant === 'blog') {
    return <BlogHeader dark={dark} onToggleDark={onToggleDark} onGoHome={onGoHome!} />;
  }

  return (
    <div className="px-6 md:px-40 flex justify-center py-5">
      <div className="flex flex-col max-w-[960px] flex-1">
        <header
          className={cn(
            'flex items-center justify-between whitespace-nowrap border-b border-solid px-4 md:px-10 py-6',
            dark ? 'border-[#283539]' : 'border-slate-200'
          )}
        >
          <div
            className={cn(
              'flex items-center gap-4',
              dark ? 'text-white' : 'text-slate-900'
            )}
          >
            <img src="/logo.svg" alt="<fok:/>" className="h-6 w-auto" />
          </div>

          <div className="flex flex-1 justify-end gap-8 items-center">
            <nav className="hidden md:flex items-center gap-9">
              <span
                className={cn(
                  'text-sm font-medium leading-normal border-b-2',
                  dark ? 'text-white' : 'text-slate-900'
                )}
                style={{ borderColor: PRIMARY }}
              >
                Home
              </span>

              <NavButton dark={dark} onClick={onGoNotes}>
                Notes
              </NavButton>
            </nav>
            <ThemeToggle dark={dark} onToggle={onToggleDark} />
          </div>
        </header>
      </div>
    </div>
  );
}

function BlogHeader({
  dark,
  onToggleDark,
  onGoHome,
}: {
  dark: boolean;
  onToggleDark: () => void;
  onGoHome: () => void;
}) {
  return (
    <header
      className={cn(
        'flex items-center justify-between whitespace-nowrap border-b border-solid px-6 md:px-20 py-4 sticky top-0 z-40',
        dark ? 'border-slate-800 bg-[#101e22]' : 'border-slate-200 bg-[#f5f8f8]'
      )}
    >
      <div className="flex items-center gap-4">
        <button
          className="group flex items-center gap-2"
          onClick={onGoHome}
          type="button"
        >
          <img src="/logo.svg" alt="<fok:/>" className="h-6 w-auto" />
        </button>
      </div>

      <div className="flex flex-1 justify-end gap-4 md:gap-8 items-center">
        <nav className="hidden md:flex items-center gap-9">
          <NavButton dark={dark} onClick={onGoHome} variant="muted">
            Home
          </NavButton>
          <span
            className={cn(
              'text-sm font-medium leading-normal border-b-2',
              dark ? 'text-white' : 'text-slate-900'
            )}
            style={{ borderColor: PRIMARY }}
          >
            Notes
          </span>
        </nav>

        <ThemeToggle dark={dark} onToggle={onToggleDark} size="sm" />
        {/*//TODO: lets enable this button once we can subscribe*/}
        {/*<button*/}
        {/*  className="flex min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded h-9 px-4 text-sm font-bold leading-normal tracking-tight hover:brightness-110 transition-all"*/}
        {/*  style={{ backgroundColor: PRIMARY, color: '#101e22' }}*/}
        {/*  type="button"*/}
        {/*>*/}
        {/*  */}
        {/*  <span className="truncate">Subscribe</span>*/}
        {/*</button>*/}
      </div>
    </header>
  );
}

// function NavLink({
//   dark,
//   href,
//   children,
// }: {
//   dark: boolean;
//   href: string;
//   children: React.ReactNode;
// }) {
//   return (
//     <a
//       className={cn(
//         'text-sm font-medium leading-normal transition-colors hover:opacity-90',
//         dark
//           ? 'text-white hover:text-[var(--primary)]'
//           : 'text-slate-600 hover:text-[var(--primary)]'
//       )}
//       href={href}
//       style={{ '--primary': PRIMARY } as React.CSSProperties}
//     >
//       {children}
//     </a>
//   );
// }

function NavButton({
  dark,
  onClick,
  children,
  variant = 'default',
}: {
  dark: boolean;
  onClick: () => void;
  children: React.ReactNode;
  variant?: 'default' | 'muted';
}) {
  return (
    <button
      className={cn(
        'text-sm font-medium leading-normal transition-colors',
        variant === 'muted'
          ? dark
            ? 'text-slate-400 hover:text-[var(--primary)]'
            : 'text-slate-600 hover:text-[var(--primary)]'
          : dark
            ? 'text-white hover:text-[var(--primary)]'
            : 'text-slate-600 hover:text-[var(--primary)]'
      )}
      onClick={onClick}
      style={{ '--primary': PRIMARY } as React.CSSProperties}
      type="button"
    >
      {children}
    </button>
  );
}
